import { connect } from 'react-redux';
//
import ParetoDefaultView from 'pages/pareto/default-view/ParetoDefaultView';
import { IStoreState } from 'store';
import { EDisplay } from 'components/deal-results/product-items';
import { IParetoProductWithDetails } from 'store/pareto/types';
import { getPricePerUnitLabel } from 'store/deal-comparison/selectors';
import { setSelectedDisplay } from 'store/deal-comparison/actions';
import { IStatusFieldOption } from 'store/field-options/types';
import { EEvaluationUnit } from 'store/deal-evaluation/types';
import labels from 'constants/labels';
import { getParetoDealProducts, getParetoLegendText, getStatusesForLegend } from 'pages/pareto/selectors';
import { removeParetoDealAndId } from 'store/pareto/actions';

export interface IParetoDefaultViewStateProps {
  availableStatuses: IStatusFieldOption[];
  legendText: string;
  paretoDealProducts: IParetoProductWithDetails[];
  pricePerUnitLabel: string;
  selectedDisplay: EDisplay;
  selectedUnitType: EEvaluationUnit;
  volumeUnitLabel: string;
  hasVolumeWidthBars: boolean;
}

export interface IParetoDefaultViewDispatchProps {
  setSelectedDisplay: (display: EDisplay) => void;
  removeParetoDealAndId: (dealName: string, dealId: string) => void;
}

export type TParetoDefaultViewProps = IParetoDefaultViewStateProps & IParetoDefaultViewDispatchProps;

const mapStateToProps = (state: IStoreState): IParetoDefaultViewStateProps => ({
  availableStatuses: getStatusesForLegend(state),
  legendText: getParetoLegendText(state),
  paretoDealProducts: getParetoDealProducts(state),
  pricePerUnitLabel: getPricePerUnitLabel(state),
  selectedDisplay: state.dealComparison.selectedDisplay,
  selectedUnitType: state.dealEvaluation.selectedUnitType,
  volumeUnitLabel:
    state.dealEvaluation.selectedUnitType === EEvaluationUnit.LBS ? labels.volume.pound : labels.volume.ton,
  hasVolumeWidthBars: state.pareto.hasVolumeWidthBars,
});

const mapDispatchToProps = {
  removeParetoDealAndId,
  setSelectedDisplay,
};

export default connect(mapStateToProps, mapDispatchToProps)(ParetoDefaultView);
